import React from 'react';

export default function Toast({ message }) {
  if (!message) return null;
  return (
    <div className="fixed bottom-8 left-1/2 -translate-x-1/2 bg-surface3 border border-borderB rounded-full px-5 py-2.5 text-sm font-medium z-[200] whitespace-nowrap animate-fade-up shadow-lg">
      {message}
    </div>
  );
}
